/* eslint-disable import/prefer-default-export */
import DashTabulator from './components/DashTabulator.react';

export {
    DashTabulator
};
